import { useCallback } from "react";

import { Box, Flex } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { Page } from "shared/components/Page";
import { NavigationHeader } from "ui/NavigationHeader/NavigationHeader";
import { TitleM } from "ui/Typography/Typography";

import { InventoryProduct } from "../../../shared/models/inventoryProduct/types";
import { ProductsList } from "../components/ProductsList";
import { useBbdCorrectionActions } from "../stores/useBbdCorrectionActions";
import { useBbdCorrectionStore } from "../stores/useBbdCorrectionStore";

export function SelectBbdProductPage() {
  const intl = useIntl();

  const inventoryProductsList = useBbdCorrectionStore((state) => state.inventoryProductsList);

  const { selectProduct, clearListAndGoIdle, goBackToIdle } = useBbdCorrectionActions();

  const onClickProduct = useCallback(
    (product: InventoryProduct) => {
      selectProduct(product.productSku, product.shelf);
    },
    [selectProduct],
  );

  return (
    <Page isFull isBgGrey h="100%">
      <NavigationHeader
        title={intl.formatMessage({
          id: "components.inventory.bbd-correction.select-product.header-title",
          defaultMessage: "BBD Date correction",
        })}
        onClickGoBack={goBackToIdle}
      />
      <Box flex={1} flexDirection="column" w="100%" overflowY="scroll">
        <Flex alignItems="center" justifyContent="space-between" px="s200" pt="s300" pb="s200">
          <TitleM>
            {intl.formatMessage(
              {
                id: "pages.inventory.bbd-correction.results-found",
              },
              { quantity: inventoryProductsList.length },
            )}
          </TitleM>
          <TitleM color="grey.600" onClick={() => clearListAndGoIdle()}>
            {intl.formatMessage({
              id: "pages.inventory.bbd-correction.clear",
            })}
          </TitleM>
        </Flex>
        <ProductsList
          products={inventoryProductsList}
          variantSize="m"
          onClickProduct={onClickProduct}
        />
      </Box>
    </Page>
  );
}
